import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';
import {
  taxBookingDiagnosticsListSchema,
  currenciesDiagnosticsListSchema,
  obligationDiagnosticsListSchema,
  companyCodeDiagnosticsListSchema,
  legalEntityDiagnosticsListSchema,
  provisionDiagnosticsListSchema,
} from '@common/schemas/diagnostics';
import { parse } from '@common/utils/zodHelpers';

type UseDiagnosticsParams = { periodName: string, enabled: boolean };

export const useTaxBookingDiagnostics = ({ periodName, enabled }: UseDiagnosticsParams) =>
  useCustomQuery(
    [QueryKeys.diagnostics.TaxBooking, { periodName }],
    {
      url: Config.endpoints.FETCH_DIAGNOSTICS_TAX_BOOKING
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching tax booking diagnostics failed',
      defaultData: [],
      enabled,
      parser: parse(taxBookingDiagnosticsListSchema),
    }
  );

export const useCurrenciesDiagnostics = ({ periodName, enabled }: UseDiagnosticsParams) =>
  useCustomQuery(
    [QueryKeys.diagnostics.Currencies, { periodName }],
    {
      url: Config.endpoints.FETCH_DIAGNOSTICS_CURRENCIES
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching currencies diagnostics failed',
      defaultData: [],
      enabled,
      parser: parse(currenciesDiagnosticsListSchema),
    }
  );

export const useObligationDiagnostics = ({ periodName, enabled }: UseDiagnosticsParams) =>
  useCustomQuery(
    [QueryKeys.diagnostics.Obligation, { periodName }],
    {
      url: Config.endpoints.FETCH_DIAGNOSTICS_OBLIGATION
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching obligation diagnostics failed',
      defaultData: [],
      enabled,
      parser: parse(obligationDiagnosticsListSchema),
    }
  );

export const useCompanyCodeDiagnostics = ({ periodName, enabled }: UseDiagnosticsParams) =>
  useCustomQuery(
    [QueryKeys.diagnostics.CompanyCode, { periodName }],
    {
      url: Config.endpoints.FETCH_DIAGNOSTICS_COMPANY_CODE
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching company code diagnostics failed',
      defaultData: [],
      enabled,
      parser: parse(companyCodeDiagnosticsListSchema),
    }
  );

export const useLegalEntityDiagnostics = ({ periodName, enabled }: UseDiagnosticsParams) =>
  useCustomQuery(
    [QueryKeys.diagnostics.LegalEntity, { periodName }],
    {
      url: Config.endpoints.FETCH_DIAGNOSTICS_LEGAL_ENTITY
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching legal entity diagnostics failed',
      defaultData: [],
      enabled,
      parser: parse(legalEntityDiagnosticsListSchema),
    }
  );

export const useProvisionDiagnostics = ({ periodName, enabled }: UseDiagnosticsParams) =>
  useCustomQuery(
    [QueryKeys.diagnostics.Provision, { periodName }],
    {
      url: Config.endpoints.FETCH_DIAGNOSTICS_PROVISION
        .replace(/:periodName/, periodName),
      errorMessage: 'Fetching provision diagnostics failed',
      defaultData: [],
      enabled,
      parser: parse(provisionDiagnosticsListSchema),
    }
  );
